// Wrappers para /api/notepads/*.

import { apiFetch } from './api';

export interface Notepad {
  id: number;
  user_id: number;
  lesson_id: number;
  title: string;
  content: string | null;
  created_at: string;
  updated_at: string;
}

export interface NotepadTimelineItem {
  booking_id: number;
  scheduled_at: string;
  booking_type: 'one' | 'gr';
  booking_status: 'scheduled' | 'cancelled' | 'completed' | 'no_show';
  lesson_id: number;
  lesson_title: string;
  lesson_slug: string;
  notepad_id: number | null;
  notepad_title: string | null;
  notepad_excerpt: string | null;
  notepad_updated_at: string | null;
}

export async function listMyTimeline(): Promise<NotepadTimelineItem[]> {
  const r = await apiFetch<{ status: 'ok'; items: NotepadTimelineItem[] }>('/notepads/mine');
  return r.items;
}

export async function getOrCreateNotepad(lessonId: number): Promise<Notepad> {
  const r = await apiFetch<{ status: 'ok'; notepad: Notepad }>(`/notepads?lesson_id=${lessonId}`);
  return r.notepad;
}

export async function updateNotepad(
  id: number,
  patch: { title?: string; content?: string | null }
): Promise<Notepad> {
  const r = await apiFetch<{ status: 'ok'; notepad: Notepad }>(`/notepads/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return r.notepad;
}

